import _extends from 'babel-runtime/helpers/extends';
import axios from "axios";
// 登录后的跳转到当前路由的第一个页面或其子页面(目前children支持到二级)
function toPath(auths) {
  var path = '';

  if (auths[0].children && auths[0].children.length > 0 && auths[0].children[0].path !== '') {
    let secondChildren = auths[0].children[0]
    if (secondChildren.children && secondChildren.children.length > 0 && secondChildren.children[0].path !== '') {
      let thirdChildren = secondChildren.children[0]
      if (thirdChildren.children && thirdChildren.children.length > 0 && thirdChildren.children[0].path !== '') {
        path = thirdChildren.children[0].path;// 4级菜单
      } else {
        path = thirdChildren.path;// 3级菜单
      }
    } else {
      path = secondChildren.path;// 2级菜单
    }
  } else {
    path = auths[0].path;
  }
  return path;
}
function getParam(name, defaultValue) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == name) { return pair[1]; }
  }
  return (defaultValue == undefined ? null : defaultValue);
}
function getToken(data) {
  var formData = new FormData();
  for (var i in data) {
    if (Array.isArray(data[i])) {
      data[i].map(function (item) {
        if (item.raw) {
          formData.append(i, item.raw);
        } else {
          formData.append(i, item);
        }
      });
    } else {
      formData.append(i, data[i]);
    }
  }
  return axios({
    url: '/api/oauth2/token',
    method: 'post',
    data: formData
  })
}
function doLoginByToken(data) {
  var formData = new FormData();
  for (var i in data) {
    if (Array.isArray(data[i])) {
      data[i].map(function (item) {
        if (item.raw) {
          formData.append(i, item.raw);
        } else {
          formData.append(i, item);
        }
      });
    } else {
      formData.append(i, data[i]);
    }
  }
  return axios({
    url: '/xxl-sso-server/doLoginByToken',
    method: 'post',
    data: formData
  })
}
/**
 * 路由缓存规则：
 * 1.如果to是from的子页面，那么from加入缓存
 * 2.如果to不是from的子页面，寻找缓存中是否有该页面，有的话清除缓存
 */
function routerKeepAlive(store, to, from) {
  var fromElem = recursion(store.getters.getAuth[0].children, from.path);
  var toElem = recursion(store.getters.getAuth[0].children, to.path);
  if (toElem && fromElem) {
    if (fromElem.children && fromElem.children.length > 0) {
      // 规则1
      if (recursion(fromElem.children, toElem.path)) {
        var index = store.state.keepAliveRoutes.findIndex(function (elem) {
          return elem === updatePathToName(fromElem.path);
        });
        if (index === -1) {
          store.state.keepAliveRoutes.push(updatePathToName(fromElem.path));
        }
      }
    }
    if (!fromElem.children || !recursion(fromElem.children, toElem.path)) {
      // 规则2
      var _index = store.state.keepAliveRoutes.findIndex(function (elem) {
        return elem === updatePathToName(fromElem.path);
      });
      if (_index > -1) {
        store.state.keepAliveRoutes.splice(_index, 1);
      } else {
        // store.state.keepAliveRoutes = []
      }
    }
  }
}
function recursion(tree, path) {
  for (var i = 0; i < tree.length; i++) {
    if (tree[i].path === path) {
      return tree[i];
    } else if (tree[i].children && tree[i].children.length > 0) {
      var res = recursion(tree[i].children, path);
      if (res) {
        return res;
      }
    }
  }
}

// 将 /path/list 改为 PathList
function updatePathToName(path) {
  var _routeNameArr = path.slice(1).split('');
  _routeNameArr.forEach(function (elem, index) {
    if (elem === '/') {
      _routeNameArr[index + 1] = _routeNameArr[index + 1].toUpperCase();
      _routeNameArr.splice(index, 1);
    }
  });
  return _routeNameArr.join('');
}

// 路由前置守卫
function routerEngin(router, store) {
  router.beforeEach(function (to, from, next) {
    if (process.env.IS_AUTH=='true' && getParam('code')) {
      getToken({
        code: getParam('code'),
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        grant_type: 'authorization_code',
        redirect_uri: process.env.REDIRECT_URI,
      }).then(res => { 
        sessionStorage.setItem('access_token', res.access_token)
        doLoginByToken({ token: res.access_token }).then(res => { 
          window.location.href=res
        })
      })
    } else {
      if (store.getters.getAuth.length === 0 && !store.getters.getAuthHad) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('getAuth').then(function () {
          // 需要缓存的路由处理
          if (store.state.keepAliveRoutes && store.getters.getAuth.length > 0) routerKeepAlive(store, to, from);
          setTimeout(function () {
            let accessRoutes = store.getters.getAuth
            // for(let i=0,length=accessRoutes.length;i<length;i+=1){
            //   const element=accessRoutes[i]
            //   router.addRoute(element)
            // }
            // 拉取info
            router.addRoutes(store.getters.getAuth); // 动态添加可访问路由表
            if (to.path === '/') {
              next({ path: toPath(store.getters.getAuth[0].children) });
            } else {
              next(_extends({}, to, { replace: true })); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            }
          }, 0);
        }).catch(function (err) {
          next();
          console.error(err);
        });
      } else {
        // 需要缓存的路由处理
        if (store.state.keepAliveRoutes && store.getters.getAuth.length > 0) routerKeepAlive(store, to, from);
        setTimeout(function () {
          if (to.path === '/') {
            next({ path: toPath(store.getters.getAuth[0].children) });
          } else {
            next(); //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
          }
        }, 0);
      }
    }
    
  });
}

export default routerEngin;


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/router/engine.js
// module id = null
// module chunks = 